<template>
  <section class="faq-box">
    <div class="container">
      <div class="faq-box__title-box">
        <h2 class="faq-box__title">Frequently Asked Questions</h2>
      </div>

      <slot></slot>
    </div>
  </section>
</template>

<style lang="scss">
.faq-box {
  padding: 60px 0;

  &__title {
    font-size: 32px;
    font-weight: 400;
    line-height: 32px;
  }
}

.night-mode {
  .faq-box {
    background: $c-bg-5;
  }
}
</style>
